import axios from "axios";
import { FETCH_ORDER_HISTORY, SET_ORDER_ID } from "./actionTypes";

export const fetchOrderHistory = (userId) => (dispatch) => {
  const requestData = {
    user_id: userId,
  };

  return axios
    .post("/orders", requestData)
    .then((response) => {
      const orderHistoryData = response.data.data.orders; // debug voor te veel producten. We moeten pagina's inbrengen.

      dispatch({
        type: FETCH_ORDER_HISTORY,
        payload: orderHistoryData,
      });
    })
    .catch((err) => {
      console.log(
        "[OrderHistory.actions.js] fetchOrderHistory|| Could not fetch order history. Try again later."
      );
    });
};

export const fetchSingleOrderData = (order_id, setOrder) => {
  const requestData = {
    order_id: order_id,
  };

  return axios
    .post("/order", requestData)
    .then((response) => {
      setOrder(response.data.data.order);
    })
    .catch((err) => {
      console.log(
        "[OrderHistory.actions.js] fetchOrderHistory|| Could not fetch order history. Try again later."
      );
    });
};

export const setOrderId = (orderId) => (dispatch) => {
  dispatch({
    type: SET_ORDER_ID,
    payload: orderId,
  });
};
